import sensors from 'sa-sdk-javascript';
import { history } from 'umi';
// 引入神策插件
import pageleave from 'sa-sdk-javascript/dist/web/plugin/pageleave/index.es6.js';
import pageload from 'sa-sdk-javascript/dist/web/plugin/pageload/index.es6.js';

// 神策初始化
export function sensorsInit(url) {
  // 从 url 中提取 origin（协议+ip+端口），拼接新路径作为 white_list
  // let whiteListUrl = '';
  // try {
  //   const urlObj = new URL(url);
  //   whiteListUrl = `${urlObj.origin}/dxp/cdp/v1/datagather/sa.gif`;
  // } catch (e) {
  //   // url 解析失败时使用默认值
  // }

  sensors.init({
    server_url: url, // todo
    // is_track_single_page: true, // 单页面配置，默认开启，若页面中有锚点设计，需要将该配置删除，否则触发锚点会多触发 $pageview 事件
    use_client_time: true,
    // show_log: true,
    send_type: 'beacon',
    app_js_bridge: true,
    // app_js_bridge: {
    //   white_list: [whiteListUrl, 'https://10.10.178.184:8082/dxp/cdp/v1/datagather/sa.gif'],
    // },
    heatmap: {
      // 是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
      clickmap: 'default',
      // 是否开启触达注意力图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
      scroll_notice_map: 'default',
    },
  });

  // 注册页面离开事件插件
  sensors.use(pageleave, {
    heartbeat_interval_time: 5, // 心跳上报间隔，单位秒
    max_duration: 5 * 24 * 60 * 60, // 最大停留时长，单位秒
    // eslint-disable-next-line func-names, object-shorthand, no-shadow, no-unused-vars
    isCollectUrl: function (url) {
      // url 为要采集页面浏览时长的页面地址。
      // 返回 true 采集，false 不采集
      return true;
    },
  });

  // 注册页面加载事件插件
  sensors.use(pageload);

  sensors.quick('autoTrack');
  return sensors;
}

// 谷歌 GA 专用事件白名单：命中则只上报谷歌 GA、不上报神策
// 需要某个事件“只上报谷歌”时，把事件名加进该数组即可
const GOOGLE_ONLY_EVENTS = [
  'reward_databank',
  'reward_order_summary',
  'reward_order_complete',
  'reward_order_failed',
  'reward_listing',
  'reward_detail',
  'reward_exclusive_listing',
  'reward_home',
];

// 谷歌 GA 属性黑名单：上报谷歌时这些属性一律剔除（敏感/身份信息，避免随事件上报）
const GA_BLOCKED_PROPS = [
  '$device_id',
  '$identity_email',
  '$identity_login_id',
  '$identity_mobile',
  '$latitude',
  '$longitude',
  'nationalId',
  'msisdn',
  'receivedPhoneNum',
  'sendAccount',
];

// 业务埋点统一入口：白名单内事件只上报谷歌 GA，其余上报神策
export function trackSensors(EventSystemName, data) {
  // 命中白名单：只上报谷歌 GA，不上报神策
  if (GOOGLE_ONLY_EVENTS.includes(EventSystemName)) {
    // 先剔除属性黑名单中的敏感字段，再上报谷歌 GA
    const gaData = {};
    if (data) {
      Object.keys(data).forEach(key => {
        if (!GA_BLOCKED_PROPS.includes(key)) {
          gaData[key] = data[key];
        }
      });
    }
    try {
      window.gtag('event', EventSystemName, {
        platform: window.__GA_PLATFORM__ || '',
        ...gaData,
      });
    } catch {
      // GA 上报失败不影响主业务
    }
    return;
  }
  const initAppStr = window.localStorage.getItem('initApp');
  const initApp = JSON.parse(initAppStr) || {};
  const { gameCode } = history.location.query || JSON.parse(localStorage.getItem('gameCode'));
  let appSensorsData = {};
  try {
    const appSensors = window?.clp?.getTraceSuperAndPresetProperties();
    appSensorsData = JSON.parse(appSensors) || {};
  } catch {
    appSensorsData = {};
  }
  const payload = {
    gameCode,
    channel: 'H5',
    ...appSensorsData,
    ...(data || {}),
  };
  if (initApp.busiBrand) {
    payload.busiBrand = initApp.busiBrand;
  }
  sensors.track(EventSystemName, payload);
}

// 用户信息
export function setProfile(data) {
  sensors.setProfile(data);
}

// ============================================================
// 谷歌 GA 埋点（使用 gtag.js 方案）
// ============================================================
//
// 为什么用 gtag.js 而不是 Firebase SDK？
// 1. Firebase SDK 需要完整的 Firebase 配置（apiKey、projectId、appId 等），
//    而新项目只会提供一个 measurementId（如 "G-XXXXXXXXXX"），Firebase SDK 无法初始化。
// 2. gtag.js 是 Google 官方推荐的纯 GA 埋点方案，只需 measurementId 即可工作，
//    无需依赖 Firebase 生态，包体积更小。
// 3. gtag.js 通过动态注入 <script> 标签加载，不占用项目打包体积。
// ============================================================

// gtag 函数：向 dataLayer 推送数据，由 Google Tag Manager 脚本消费并发送到 GA 服务器
// 必须挂到 window 上，因为 gtag.js 加载后依赖 window.gtag 处理命令队列
window.gtag = function gtag() {
  window.dataLayer = window.dataLayer || [];
  // eslint-disable-next-line prefer-rest-params
  window.dataLayer.push(arguments);
};

/**
 * 初始化谷歌 GA 埋点
 * @param {string} configStr - JSON 字符串，包含 measurementId（GA4 衡量 ID）和 platform（平台标识）
 *   示例：'{"measurementId":"G-XXXXXXXXXX","platform":"gomo"}'
 *
 * 原理：
 * 1. 解析配置 JSON，提取 measurementId 和 platform
 * 2. 在 window 上挂载 dataLayer 和 gtag 函数（必须在脚本加载前完成，这样 gtag.js 加载后才能消费已入队的命令）
 * 3. 调用 gtag('js') 和 gtag('config') 把初始化命令入队到 dataLayer
 * 4. 动态注入 gtag.js 脚本，脚本加载后会处理 dataLayer 中已入队的命令
 * 5. 之后通过 trackSensors 上报自定义事件：白名单(GOOGLE_ONLY_EVENTS)内事件走谷歌 GA（platform 作为公共属性自动带上），其余走神策
 */
export const initGoogleGA = configStr => {
  if (!configStr) return;
  try {
    const config = JSON.parse(configStr);
    const { measurementId, platform } = config;
    if (!measurementId) return;

    // 存储 platform 到全局，后续埋点上报时作为公共属性使用
    window.__GA_PLATFORM__ = platform || '';

    // 初始化命令入队：记录启动时间、配置衡量 ID
    // transport_type: 'beacon' 使用 navigator.sendBeacon() 发送数据，
    // 确保页面跳转时已触发的事件不会被取消，可靠送达 GA 服务器
    window.gtag('js', new Date());
    window.gtag('config', measurementId, { transport_type: 'beacon' });
    
    // 动态注入 gtag.js 脚本，脚本加载后会自动处理 dataLayer 中已入队的命令
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
    document.head.appendChild(script);
  } catch {
    // GA 初始化失败不影响主业务
  }
};
